/**
 * The Export and Columns controls above the call-off list.
 *
 * CR-7732 gave the haulier this pair; CR-7782 gives it to every role, with the
 * Columns control reordering as well as hiding.
 *
 * Export writes what is on screen — the rows the current filters returned,
 * with the columns the viewer has chosen — because a file that disagrees with
 * the list it came from is worse than no file. It offers the same two files as
 * the Stock Planning export: a styled Excel workbook, or a CSV.
 */
import type { CallOffColumn } from './callOffColumnConfig';
import type { ExportFormat } from './useCallOffExport';
import CallOffExportMenu from './CallOffExportMenu';
import CallOffColumnsMenu from './CallOffColumnsMenu';

interface CallOffListToolbarProps {
  /** Every column offered to this viewer, in the viewer's order. */
  columns: readonly CallOffColumn[];
  isVisible: (id: string) => boolean;
  onToggle: (id: string) => void;
  onMove: (from: number, to: number) => void;
  onShowAll: () => void;
  onReset: () => void;
  hiddenCount: number;
  /** Write the current rows to a file. Disabled while there are none. */
  onExport: (format: ExportFormat) => void;
  exportDisabled: boolean;
  exporting: boolean;
}

export default function CallOffListToolbar({
  columns, isVisible, onToggle, onMove, onShowAll, onReset, hiddenCount,
  onExport, exportDisabled, exporting,
}: CallOffListToolbarProps) {
  return (
    <div className="flex items-center gap-2">
      <CallOffExportMenu onExport={onExport} disabled={exportDisabled} exporting={exporting} />
      <CallOffColumnsMenu
        columns={columns}
        isVisible={isVisible}
        onToggle={onToggle}
        onMove={onMove}
        onShowAll={onShowAll}
        onReset={onReset}
        hiddenCount={hiddenCount}
      />
    </div>
  );
}
